module.exports = __webpack_public_path__ + "img/environment.4665776.jpg";